import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';

const routes = [
  {
    path: 'home',
    component: HomeComponent,
    data: { title: 'WO Applications' },
    pathMatch: 'full' as 'full',
  },
  {
    path: 'admin',
    component: AdminComponent,
    data: { title: 'WO Admin Applications' },
    pathMatch: 'full' as 'full',
  },
  // final fallback
  {
    path: '**',
    redirectTo: '/home',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
